import React from "react";
import { Button, ButtonSize, ButtonVariant, MITheme } from "@spectrumselect/mi-ui-react";
import { local } from "../../internationalization/Localization";
import { S } from "../../auth/sdk";

export interface ProcessJsonDataProps {
  jsonData: object;
  actionContext: com.ts.mobile.sdk.PolicyAction | null;
  resolve: (value: any | PromiseLike<any>) => void;
}

export const ProcessJsonData: React.FunctionComponent<ProcessJsonDataProps> = (props) => {

  const onButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    props.resolve(S.JsonDataProcessingResult.create(true));
  }

  return (
    <div className="ProcessJsonData">
      <h1 className="App_pageTitle">JSON Data received from TS Server</h1>
      <p className="App_formDesc">{JSON.stringify(props.jsonData, null, 2)}</p>
      <div className="App_formButtonGroup">
        <Button
          variant={ButtonVariant.primary}
          onClick={onButtonClick}
          theme={MITheme.dark}
          size={ButtonSize.large}
        >
          {local.get("buttonLabels[5]")}
        </Button>
      </div>
    </div>
  );
}
